module.exports = __webpack_public_path__ + "static/img/10011 (2).5b52fb4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10011 (2).webp
// module id = 42Ac
// module chunks = 14